import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LightBox } from '@lion-design/core';
import { RootState } from '@Redux/search/store';
import { useMediaQuery } from 'react-responsive';
import { getIsFavorite } from '@utils/favorite';
import { member } from '@utils/domainByEnv';
import { buildQueryString } from '@utils/utils';
import domainByEnv from '@utils/domainByEnv';
import Pc from './subComponent/Pc';
import M from './subComponent/M';
import styles from './styles.module.scss';
import { filterTypesKey, I_FilterItem } from '@Redux/search/interfaces';

declare global {
    interface Window {
        CancelFavorite: any;
    }
}

const IsB2E = document.getElementById('searchPagePara')?.dataset?.isb2e === 'False';
const IsOPAPP = document.getElementById('searchPagePara')?.dataset?.isopapp === 'False';
// 不是 B2E 且不是 opapp 導購行為才需要加
const Platform = IsB2E && IsOPAPP ? 'APP' : '';
const urlParams = new URLSearchParams(window.location.search);
const IsEnsureGroup = urlParams.get('IsEnsureGroup') || '';

const handleIsFav = (groupID: string, list: any) => {
    return list?.find((favItem: any) => favItem.ProductID === groupID) || false;
};

const ResultCards = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const [isLogin, setIsLogin] = useState<boolean>(false);
    const [openLightbox, setOpenLightBox] = useState(false);
    const [favList, setFavList] = useState<any>();

    // 確認是否登入
    useEffect(() => {
        (async function () {
            try {
                const memberRes = await fetch(`${member}/account/checkmemberlogin`, {
                    method: 'post',
                    // 會帶 cookie 過去
                    credentials: 'include',
                });
                const memberData = await memberRes.json();
                setIsLogin(memberData.IsLogin);
            } catch (ex) {
                console.log('Fetch Member Data Error', ex);
            }
        })();
    }, []);

    // 一進頁面時，如果有 Login，則判斷有沒有加入收藏
    useEffect(() => {
        if (isLogin) {
            (async () => {
                const initFavList = await getIsFavorite('0');
                setFavList(initFavList);
            })();
        }
    }, [isLogin]);

    // 篩選條件
    const { FilterItems, TagFiltersShow } = useSelector((state: RootState) => state.search);
    const GroupListData = useSelector(
        (store: RootState) => store.search.GroupListInfo.data || store.search.GroupListInfoM.data
    );
    const PreferAirlines = FilterItems.filter((item: I_FilterItem) => {
        return item.filterBy === filterTypesKey.AirlineList;
    })
        .map((item: I_FilterItem) => item.value)
        .join(',');

    // 組結果頁往產品頁的網址
    const productUrl = (params: { [key: string]: string }) => {
        const detailPageParams = buildQueryString({
            ...params,
            IsEnsureGroup,
            Platform,
            PreferAirlines,
        });
        return `${domainByEnv(false)}/detail?${detailPageParams}`;
    };

    useEffect(() => {
        if (!GroupListData) return;
        const checkFilter = FilterItems.every((item: any) => item.filterBy === 'TravelType');

        // 篩選時不觸發單一產品跳轉
        if (
            TagFiltersShow.length === 0 && // 交通篩選
            checkFilter && // 左側篩選
            GroupListData?.NormGroupList.length === 1 &&
            GroupListData?.CurrentPage === 1
        ) {
            const thisProduct = GroupListData.NormGroupList[0];
            setTimeout(() => {
                window.location.href = productUrl({
                    NormGroupID: thisProduct.NormGroupID,
                    GroupID: thisProduct.GroupList[0].GroupID,
                });
            }, 100);
            setOpenLightBox(true);
        }
    }, [GroupListData]);

    return (
        <div>
            {isMobile ? (
                <M
                    isLogin={isLogin}
                    favList={favList}
                    setFavList={setFavList}
                    productUrl={productUrl}
                    handleIsFav={handleIsFav}
                />
            ) : (
                <Pc
                    isLogin={isLogin}
                    favList={favList}
                    setFavList={setFavList}
                    productUrl={productUrl}
                    handleIsFav={handleIsFav}
                />
            )}
            <LightBox
                open={openLightbox}
                closeBtn={false}
                ToggleLightBox={() => {}}
                className={`${styles.oneResultHint}`}
            >
                <div className={styles.hintText}>
                    <span>搜尋結果只有一筆，</span>
                    <span>為您直接進入產品頁...</span>
                </div>
            </LightBox>
        </div>
    );
};

export default ResultCards;
